<template>
  <Modal :closeBtnHidden="loading" :allowClickOutsideToClose="false" @close="close">
    <div class="modal-content-wrapper">
      <h1>Edit Student Information</h1>
      <StudentInformationForm
        @studentUpdated="emit('studentUpdated', $event)"
        :disabled="loading"
        :loading="loading || gettingData"
        :student="student"
      />
    </div>
  </Modal>
</template>
<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import Modal from "@/components/shared/Modal.vue";
import StudentInformationForm from "./StudentInformationForm.vue";
import type { StudentVM } from "@/models/student";

const store = useStore();

const props = defineProps<{
  loading: boolean;
  disabled: boolean;
  student: StudentVM | null;
}>();

const emit = defineEmits<{
  (e: "studentUpdated", student: StudentVM): void;
  (e: "close"): void;
}>();

const gettingData = ref<boolean>(true);

function close() {
  emit("close");
}

onMounted(async () => {
  await store.dispatch(
    "applicationInfoModule/getStudentInfo",
    store.state.appData.application.referenceId,
  );

  gettingData.value = false;
});
</script>

<style scoped>
h1 {
  color: #000;
  font-family: "Montserrat";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 17.175px; /* 71.563% */
  padding: 0 1rem;
  margin-bottom: 2rem;
}

.modal-content-wrapper {
  padding: 0 1rem 1rem;
}
</style>
